/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconDocSite16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDocSite16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path d="M4.65 7.667h6.65V9H4.65V7.667ZM8.633 10.333H4.65v1.333h3.983v-1.333Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.61 2.94C14 3.58 14 4.454 14 6.2v3.6c0 1.746 0 2.619-.39 3.26-.219.359-.519.66-.875.88-.637.393-1.505.393-3.24.393h-2.99c-1.735 0-2.602 0-3.24-.393a2.659 2.659 0 0 1-.874-.88C2 12.419 2 11.546 2 9.8L2 6.2c0-1.746 0-2.619.39-3.26.219-.359.519-.66.875-.88.637-.393 1.505-.393 3.24-.393h2.99c1.735 0 2.602 0 3.24.392.356.22.656.522.874.88Zm-.935 3.393h-9.35V9.8c0 .899.002 1.479.043 1.918.04.419.106.57.153.645.109.18.259.33.437.44.075.047.225.114.641.154.436.041 1.013.043 1.906.043h2.99c.894 0 1.47-.002 1.906-.043.417-.04.566-.107.642-.154.178-.11.328-.26.437-.44.046-.076.113-.226.152-.645.042-.439.043-1.02.043-1.918V6.333Zm-.769-2.005a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconDocSite24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDocSite24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="M6.975 11.5h9.974v2H6.975v-2ZM12.95 15.5H6.974v2h5.974v-2Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.414 4.41c.585.962.585 2.271.585 4.89L21 14.7c0 2.619 0 3.928-.586 4.89-.327.538-.777.99-1.312 1.32-.956.59-2.257.59-4.859.59H9.757c-2.602 0-3.903 0-4.858-.59a3.988 3.988 0 0 1-1.313-1.32c-.585-.962-.585-2.271-.585-4.89L3 9.3c0-2.619 0-3.928.586-4.89.327-.538.777-.99 1.312-1.32.956-.59 2.257-.59 4.859-.59h4.486c2.602 0 3.903 0 4.859.59.534.33.984.782 1.312 1.32ZM19.012 9.5H4.987l.001 5.2c0 1.348.002 2.219.064 2.877.06.628.16.854.229.968.164.27.389.495.656.66.113.07.337.17.962.23.654.063 1.519.065 2.858.065h4.486c1.34 0 2.205-.002 2.859-.065.625-.06.849-.16.962-.23.267-.165.492-.39.656-.66.07-.114.17-.34.228-.968.063-.658.065-1.529.065-2.877V9.5ZM17.86 6.492a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconDocSite = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDocSite(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconDocSite16 {...iconProps} />;
        case '24':
            return <IconDocSite24 {...iconProps} />;
        default:
            return <IconDocSite24 {...iconProps} />;
    }
});
